import AdresHelper from "../../common/AdresHelper";
import mergeDeep from "../../../util/mergeDeep.js";
import nieuweSportclubApi from "../../../api/nieuweSportclubApi";
import assign from 'object-assign';
import { orderByPropertyName, orderByPropertyNameDesc } from "../../../util/orderBy.js";
import { LandCodes } from "../../../constants/DomainConstants";

export default class AdresPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");
        context.AdresHelper = new AdresHelper(context);

        context.setState({
            model: context.props.storeModel
        });
    }

    goToNext() {
        this.redirector.goTo("/nieuweSportclub/sporttak");
    }

    goToPrev() {
        this.redirector.goTo("/nieuweSportclub/identificatie");
    }

    onClickAdd() {
        this.context.AdresHelper.editNewAdres(() => {
            let model = mergeDeep({}, this.context.state.editingAdres);
            model['isNew'] = true;
            model['soortAdres'] = "3";
            model['toonOpKaart'] = true;

            this.context.setState({
                addMode: true,
                editingAdres: model,
                landHasFocus: true
            });
        });
    }

    onCancelAdd() {
        this.context.setState({
            addMode: false,
            errors: {}
        });
    }

    onChange(event) {
        const context = this.context;

        const property = event.target.name;
        const value = event.target.value;

        if (context.AdresHelper.changeAdresField(property, value)) return;

        const model = context.state.editingAdres;
        if (property === "toonOpKaart") {
            model.toonOpKaart = event.target.checked;
        }
        else {
            model[property] = value;
        }

        context.setState({
            editingAdres: model
        });
    }

    closeUnknownAdresModal() {
        this.context.setState({ showUnknownToPartnerModal: false });
    }

    confirmUnknownAdres() {
        this.context.setState({ showUnknownToPartnerModal: false });
        this.onSaveNewAdres(true);
    }

    onSaveNewAdres(unknownConfirmed) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        let model = mergeDeep({}, context.state.editingAdres);

        if (!unknownConfirmed
            && model.land === LandCodes.BELGIE
            && ((!model.straatId && model.straat))) {
            this.context.setState({ showUnknownToPartnerModal: true });
            return;
        }

        model.soortAdres = parseInt(model.soortAdres);
        ajaxActions.started();
        return nieuweSportclubApi.validateAdres(model)
            .then((response) => {
                ajaxActions.ended();
                if (!response.data.hasValidationErrors) {
                    let model = mergeDeep({}, context.state.model);
                    model.adressen.push(response.data.item);
                    model.adressen = orderByPropertyNameDesc(model.adressen, "soortAdres");
                    context.setState({
                        addMode: false,
                        model: model,
                        errors: {}
                    });
                }
                else {
                    context.setState({
                        errors: assign({}, response.data.validationResults)
                    });
                }
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    deleteAdres(id) {
        this.context.setState({
            deletingAdresId: id
        });
    }

    confirmDelete() {
        let model = mergeDeep({}, this.context.state.model);
        model.adressen = model.adressen.filter(x => x.id !== this.context.state.deletingAdresId);

        this.context.setState({
            deletingAdresId: null,
            model: model
        });
    }

    cancelDelete() {
        this.context.setState({
            deletingAdresId: null
        });
    }
}